<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <Entries1cComponent/>

    </transition>
  </div>
</template>

<script>

import Entries1cComponent from '@/components/Entries1cComponent.vue'

export default {
  name: 'Entries1c',
  components: {
    Entries1cComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
